import { current } from '@reduxjs/toolkit';
import _ from 'lodash';

export function shuffle() {
  let array = [0, 1, 2, 3, 4, 5];
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
  return array;
}

export function createGrid() {

  let array0 = new Array(6).fill(0);
  let array1 = new Array(6).fill(1);
  let array2 = new Array(6).fill(2);
  let array3 = new Array(6).fill(3);
  let array4 = new Array(6).fill(4);
  let array5 = new Array(6).fill(5);

  let array = [...array0, ...array1, ...array2, ...array3, ...array4, ...array5];

  function shuffle(array) {
    let currentIndex = array.length;

    // While there remain elements to shuffle...
    while (currentIndex != 0) {

      // Pick a remaining element...
      let randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
  }

  shuffle(array);

  const chunkArray = (array, chunkSize) => {
    const numberOfChunks = Math.ceil(array.length / chunkSize)

    return [...Array(numberOfChunks)]
      .map((value, index) => {
        return array.slice(index * chunkSize, (index + 1) * chunkSize)
      })
  }

  const gridArray = chunkArray(array, 6);
  return gridArray;
}

export function incrementGrid(gridArray) {
  let tmpArray = _.cloneDeep(gridArray);

  tmpArray.map((row, rowIndex) => {
    row.map((cell, cellIndex) => {
      if (cell == 5) {
        tmpArray[rowIndex][cellIndex] = 0;
      } else {
        tmpArray[rowIndex][cellIndex] = cell + 1;
      }
    })
  });
  return tmpArray;
};

export function decrementGrid(gridArray) {
  let tmpArray = _.cloneDeep(gridArray);

  tmpArray.map((row, rowIndex) => {
    row.map((cell, cellIndex) => {
      if (cell == 0) {
        tmpArray[rowIndex][cellIndex] = 5;
      } else {
        tmpArray[rowIndex][cellIndex] = cell - 1;
      }
    })
  });
  return tmpArray;
};

// export function testCode(count, gridArray) {
export function testCode(count, gridArray, selectedCell, registeredPattern) {
  // console.log('testCode');
  // console.log('clicks: ', count);
  // console.log('selectedCell: ', selectedCell);
  // console.log('registeredPattern: ', registeredPattern);
  let tmpArray = _.cloneDeep(gridArray);
  // console.log('tmpArray: ', tmpArray);

  switch (count) {
    case 1:
      return tmpArray[registeredPattern[0][0]][registeredPattern[0][1]];
      break;
    case 2:
      return tmpArray[registeredPattern[1][0]][registeredPattern[1][1]];
      break;
    case 3:
      return tmpArray[registeredPattern[2][0]][registeredPattern[2][1]];
      break;
    case 4:
      return tmpArray[registeredPattern[3][0]][registeredPattern[3][1]];
      break;
    case 5:
      return tmpArray[registeredPattern[4][0]][registeredPattern[4][1]];
      break;
    case 6:
      return tmpArray[registeredPattern[5][0]][registeredPattern[5][1]];
      break;
    default:
      console.log('Oops!');
  }

};

const allEqual = (testCodeArray, selectedCell, codeArray) => testCodeArray.every(val => val === codeArray[selectedCell]);

export function resultTest(testCodeArray, selectedCell, codeArray) {
  // console.log('Test the result');
  // console.log('resultTest - testCodeArray: ', testCodeArray);
  // console.log('resultTest - selectedCell: ', selectedCell);
  // console.log('resultTest - codeArray: ', codeArray);
  return allEqual(testCodeArray, selectedCell, codeArray);
};